<template>
    <div>
        <titlebar :title-stack="titleStack" />
        <section class="section is-main-section">
            <div class="columns">
                <div class="column">
                    <div class="panel">
                        <p class="panel-heading">
                            Últimos Atendimentos
                        </p>
                        <div v-for="(item, index) in atendimentos" :key="index">
                            <router-link class="panel-block is-block" :to="{ name: 'atendimento', params: { id: item.id }}">
                                <p>
                                    {{item.assunto}}
                                </p>
                                <div class="is-flex is-justified-between">
                                    <small class="tag is-info">{{item.id}}</small>
                                    <small class="tag" title="Tipo de atendimento" v-if="item.tipoNome">{{item.tipoNome}}</small>
                                    <small class="tag" title="Cadastrado em">{{item.cadastradoEm | moment('DD/MM/YYYY HH:mm')}}</small>
                                </div>
                            </router-link>
                        </div>
                        <div class="panel-block">
                            <router-link class="button is-dark is-outlined is-fullwidth is-small" :to="{ name: 'atendimentos' }">Listar todos</router-link>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="panel">
                        <p class="panel-heading">
                            Projetos
                        </p>
                        <div class="panel-block is-block" v-for="(item, index) in projetos" :key="index">
                            <doughnut-chart :chart-data="item.qtdeTarefas" :height=100>
                            </doughnut-chart>
                            <h5>{{item.servicoNome}} {{item.nome}}</h5>
                            <div class="is-flex is-justified-between">
                                <small class="tag"
                                       :class="{'is-primary': item.status == 'Iniciado', 'is-warning': item.status == 'AguardandoRespostaCliente', 'is-success': item.status == 'Finalizado'}">
                                    {{ item.status }}
                                </small>
                                <small title="Prazo">{{item.prazo}}</small>
                                <router-link :to="{ name: 'tarefas', params: { id: item.id }}" class="button is-small is-link is-outlined">Tarefas</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="panel">
                        <p class="panel-heading">
                            Últimas Tarefas
                        </p>
                        <div v-for="(item, index) in tarefas" :key="index">
                            <router-link class="panel-block is-block" :to="{ name: 'tarefa', params: { id: item.id }}">
                                <p>
                                    {{item.assunto}}
                                </p>
                                <div class="is-flex is-justified-between">
                                    <small class="tag is-info">{{item.id}}</small>
                                    <small class="tag" title="Tipo de atendimento">{{item.tipoNome}}</small>
                                    <small class="tag" title="Cadastrado em">{{item.cadastradoEm | moment('DD/MM/YYYY HH:mm')}}</small>
                                </div>
                            </router-link>
                        </div>
                        <div class="panel-block">
                            <router-link class="button is-dark is-outlined is-fullwidth is-small" :to="{ name: 'tarefas' }">Listar todas</router-link>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </div>
</template>

<script>
    import titlebar from '@/components/titlebar'
    import DoughnutChart from '@/components/Charts/DoughnutChart'
    import { mapActions, mapState } from 'vuex'

    export default {
        name: 'home',
        components: {
            titlebar,
            DoughnutChart
        },
        computed: {
            titleStack() {
                return [
                    'Painel de Controle'
                ]
            },
            ...mapState('portal', [
                'atendimentos',
                'projetos',
                'tarefas',

                'atendimentosCarregados',
                'projetosCarregados',
                'tarefasCarregadas'
            ])
        },
        mounted() {
            this.carregarUltimosAtendimentos()
            this.carregarProjetos()
            this.carregarUltimasTarefas()
        },
        methods: {
            ...mapActions('portal', [
                'carregarUltimosAtendimentos',
                'carregarProjetos',
                'carregarUltimasTarefas'
            ])
        }
    }
</script>
